import { Box, Image, Collapse, Text, Stack, SimpleGrid, Button, Textarea, Flex, Input, useToast, Divider } from "@chakra-ui/react";

import imgContent01 from "../../../assets/images/content/bg/content-outsourcing-01.png";
import imgContent02 from "../../../assets/images/content/bg/content-outsourcing-02.png";
import tContent01 from "../../../assets/images/content/bg/content-tablet-outsourcing-01.png";
import tContent02 from "../../../assets/images/content/bg/content-tablet-outsourcing-02.png";
import mContent01 from "../../../assets/images/content/bg/content-mobile-outsourcing-01.png";
import mContent02 from "../../../assets/images/content/bg/content-mobile-outsourcing-02.png";

import { ReactComponent as iconCheck } from "../../../assets/icons/icon-check-circle.svg";

import { useContext, useEffect, useState } from "react";
import { ScreenContext } from "../../../components/ScreenProvider";
import { CommissionFieldList, ServiceFieldList } from "../../../assets/datas/ConstantLists";
import { styled, css } from "styled-components";

import { convertFontSize, formattedDate } from "../../../components/Util";
import StyledCalendar from "../../../components/StyledCalendar";
import { Value } from "react-calendar/dist/cjs/shared/types";
import {ReactComponent as IconCircle} from "../../../assets/icons/icon-circle.svg";
import { emailRegex, phoneNumRegex } from "../../../assets/datas/ConstantDatas";
import iconEmail from "../../../assets/icons/icon-contact-email.svg";
import iconPhone from "../../../assets/icons/icon-contact-phone.svg";
import { motion } from 'framer-motion'


const FieldWrapper = styled.div<{ $isopen: string }>`
  position: relative;
  // width: 10%;
  width: 8vw;
  max-width: 158px;
  // height: 100%;
  height: 16vw;
  overflow: hidden;
  transition: width 0.3s ease-in-out;
  display: flex;

  @media (max-width: 1024px) {
    // width: 10%;
    width: 12vw;
    height: 24vw;
    max-width: 120px;
  }
  
  ${props => props.$isopen === "true" && css`
    // width: 35%;
    width: 24vw;
    max-width: 510px;

    @media (max-width: 1024px) {
      // width: 35%;
      width: 36vw;
      max-width: 368px;
    }
  `}
`;

const CheckButton = styled(iconCheck)<{ ischeck: string }>`
  margin-right: 10px;
  fill: ${(props) => props.ischeck === "true" ? "#27C4D5" : "#ffffff"};
  stroke: ${(props) => props.ischeck === "true" ? "#27C4D5" : "#818181"};
  cursor: pointer;
`;

const Circle = styled(IconCircle)`
  fill: #27C4D5;
  width: 10px;
  margin-left: 5px;
`;

const ContactBox = styled.div`
  display: flex;
  width: 48%; 
  padding: 3% 4%;
  align-items: center;
  background: #F5F5F5;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    width: 100%;
    height: 25vw;
    padding: 5% 7%;
  } 
`;

const ImageBox = styled.div`
  display: flex;
  width: 15%; 
  height: 70%; 
  justify-content: center;

  @media (max-width: 768px) {
    width: 20%;
    height: 50%;
  } 
`;

const OutSourcing = () => {
  const screen = useContext(ScreenContext).style;
  const contents = [
    {
      pc: imgContent01,
      mobile: mContent01,
      tablet: tContent01,
    },
    {
      pc: imgContent02,
      mobile: mContent02,
      tablet: tContent02,
    },
  ];
  const fieldSize = {
    w: {
      pc: '8vw',
      tablet: '12vw',
    },
    h: {
      pc: '16vw',
      tablet: '24vw',
    },
    open: {
      pc: '24vw',
      tablet: '36vw',
    }
  };
  const toast = useToast();
  const fieldList = ServiceFieldList;
  const [show, setShow] = useState<boolean[]>(fieldList.map((f, i) => { return i === 0; }));
  const [target, setTarget] = useState<string>("App");
  const [service, setService] = useState<string>("Fn");
  const type = [target, service];
  const [isAgree, setIsAgree] = useState<boolean>(false);
  const [userInfo, setUserInfo] = useState<any>({
    name: "",
    phone: "",
    email: "",
  });

  const handleShow = (index: number) => {
    setShow(show.map((f, i) => {
      return i === index ? true : false;
    }));
  };

  const handleClick = (id: number, value: string) => {
    if(id === 0) {
      setTarget(value);
    } else {
      setService(value);
    }
  };

  const [startDate, setStartDate] = useState<string>();
  const [endDate, setEndDate] = useState<string>();
  const [calendar, setCalendar] = useState<boolean>(false);
  const [dateRange, setDateRange] = useState<Value | null>(null);

  const showCalendar = () => {
    setCalendar(true);
  };

  useEffect(() => {
    if(dateRange) dateToString();
    setCalendar(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateRange]);

  // ! calendar에서 날짜 선택을 다 하고 나면 해당 값을 state에 저장후 calendar를 닫는다.
  const handleChangeCalendar = (value: Value, event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    setDateRange(value);
    // setCalendar(false);
  };
  // ! calendar component 외 부분을 클릭 시 calendar를 닫는다.
  const handlePopupDown = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const element = e.target as HTMLElement;
    if (
      element.hasAttribute("aria-label") ||
      element.classList.contains("react-calendar__tile") ||
      element.classList.contains("react-calendar__navigation__label__labelText")
    ) {
      return;
    }
    if (calendar) {
      setCalendar(false);
    }
  };
  // ! 날짜 인풋 값에 인풋값을 cleaned하여 입력시킨다.
  const dateToString = () => {
    if (!dateRange) return; //return "날짜 선택";
    if (dateRange && dateRange[0]) {
      let startDate = formattedDate(dateRange[0]);
      let endDate = formattedDate(dateRange[1]);

      if (startDate && endDate) {
        setStartDate(startDate);
        setEndDate(endDate);
      }
    }
  };

  // ! 날짜 선택 팝업에서 날짜 range를 선택하면 호출되는 function -> 해당 date range로 filtering 해서 데이터를 fetch
  useEffect(() => {
    if (!dateRange) return;
    let startDate = dateRange[0];
    let endDate = dateRange[1];
    if (startDate && endDate) {

    }
    // eslint-disable-next-line
  }, [dateRange]);

  const [txtType, setTxtTarget] = useState<string>();
  const handleEtc = (e) => {
    setTxtTarget(e.target.value);
  };

  const handleInfo = (e, type: string) => {
    setUserInfo({
      ...userInfo,
      [type]: e.target.value 
    });
  };
  
  useEffect(() => {
    // console.log(userInfo);
  }, [userInfo]);

  const handleAgree = (e) => {
    setIsAgree((prev) => !prev);
  };

  const handleSubmit = async () => {
    if(target === "Etc" && (!txtType || txtType === "")) {
      toast({ status: "error", title: "테스트 대상을 입력해주세요."});
      return false;
    }

    if(!startDate || startDate === "" || !endDate || endDate === "") {
      toast({ status: "error", title: "테스트 일정을 선택해주세요."});
      return false;
    }

    if(!userInfo.name || userInfo.name === "") {
      toast({ status: "error", title: "이름을 입력해주세요."});
      return false;
    }

    if(!userInfo.phone || userInfo.phone === "" || !phoneNumRegex.test(userInfo.phone)) {
      toast({ status: "error", title: "올바른 연락처를 입력해주세요."});
      return false;
    }

    if(!userInfo.email || userInfo.email === "" || !emailRegex.test(userInfo.email)) {
      toast({ status: "error", title: "올바른 이메일을 입력해주세요."});
      return false;
    }
    
    if (!isAgree) {
      toast({ status: "error", title: "필수 항목에 동의해주세요."});
      return false;
    }

    toast({ status: "info", title: "준비중입니다."});
    return false;
  }

  return (
    <Box w={"100%"} display={"flex"} flexDirection={"column"} alignItems={"center"} onClick={handlePopupDown}>
      <Image 
        src={contents[0][screen]} 
        w={"100%"} 
        alt="" 
      />

      <Box 
        display={"flex"} 
        w={"100%"} 
        h={"auto"} 
        flexDir={screen === "mobile" ? "column" : "row"} 
        p={screen === "tablet" ? "0 5%" : "0 17%"} 
        justifyContent={"space-between"}
      >
        {fieldList.map((field, index) => {
          return screen !== "mobile" ? (
            <motion.div
              key={index}
              initial={false}
              animate={{ 
                width: show[index] ? fieldSize.open[screen] : fieldSize.w[screen]
              }}
              style={{
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                height: fieldSize.h[screen],
                position: 'relative',
                display: 'flex',
                borderRadius: "15px",
                cursor: "pointer",
              }}
              onClick={() => handleShow(index)}
            >
              <Image src={field.image} h={"100%"} alt="" objectFit={"cover"} />
              <Box w={"100%"} position={"absolute"} bottom={0} left={0} p={"10%"} >
                <Text whiteSpace={"pre-wrap"} fontSize={convertFontSize(16, 20, screen)} fontWeight={600} lineHeight={3.1}>
                  {`${field.id} ${show[index] ? field.title : ""}`}
                </Text>
                {show[index] &&
                  <Text whiteSpace={"pre-wrap"} lineHeight={1.5} fontSize={convertFontSize(10, 14, screen)}
                    transitionDelay={"0.3"}
                  >
                    {field.desc}
                  </Text>
                }
              </Box>
            </motion.div>
          ) : (
            <Collapse 
              key={index} 
              startingHeight={"20vw"} 
              in={show[index]} 
              onClick={() => handleShow(index)} 
              style={{ 
                position: "relative", 
                borderRadius: "15px", 
                marginBottom: "5%",
                cursor: "pointer",
                // rotate: 90,
              }}
              // transformTemplate={
              //   ({ rotate }) => `rotate(${rotate}deg)`
              // }
              // transition={{exit: {delay: 0.1}, enter: {duration: 0.3}}}
            >
              <Image src={field.image} w={"100%"} alt="" />
              {show[index] ? 
                <Box w={"100%"} position={"absolute"} top={0} left={0} p={"5% 10%"} >
                  <Text whiteSpace={"pre-wrap"} fontSize={"16px"} fontWeight={600} lineHeight={3.1}>
                    {`${field.id} ${field.title}`}
                  </Text>
                  <Text whiteSpace={"pre-wrap"} lineHeight={1.5}>
                    {field.desc}
                  </Text>
                </Box>
              :
                <Text w={"100%"} position={"absolute"} bottom={0} left={0} p={"5% 10%"} whiteSpace={"pre-wrap"} fontSize={"16px"} fontWeight={600}>
                  {field.id}
                </Text>
              }
            </Collapse>
          )
        })}
      </Box>
      <Image 
        src={contents[1][screen]} 
        w={"100%"} 
        alt="" 
      />
      <Flex 
        w={"100%"} 
        justifyContent={"space-between"} 
        mt={"50px"} 
        mb={"20%"}
        flexDir={screen === "mobile" ? "column" : "row"} 
        p={screen !== "pc" ? "0 5%" : "0 17%"} 
      >
        <ContactBox>
          <ImageBox>
            <Image h={"100%"} src={iconEmail} />
          </ImageBox>
          <Divider w={"1.5px"} h={screen === "mobile" ? "50%" : "70%"} background={"#333333"} m={"0 5%"} />
          <Stack>
            <Text color={"#333333"} fontSize={convertFontSize(21, 27)} fontWeight={600}>
              staff@tbell.co.kr
            </Text>
            <Text color={"#333333"} fontSize={convertFontSize(10, 18)}>
              이메일로 문의 가능합니다.
            </Text>
          </Stack>
        </ContactBox>
        <ContactBox>
          <ImageBox>
            <Image h={"100%"} src={iconPhone} />
          </ImageBox>
          <Divider w={"1.5px"} h={screen === "mobile" ? "50%" : "70%"} background={"#333333"} m={"0 5%"} />
          <Stack>
            <Text color={"#333333"} fontSize={convertFontSize(21, 27)} fontWeight={600}>
              070.7777.9113
            </Text>
            <Text color={"#333333"} fontSize={convertFontSize(10, 18)}>
              월-금요일 09:30-18:00 / 점심 12:00-13:00
            </Text>
          </Stack>
        </ContactBox>
      </Flex>
      <Box w={"100%"} p={"0 5%"} display={"none"}>
        {CommissionFieldList.map((commission, index) => {
          return (
            <Stack key={index} w={"100%"} p={screen === "mobile" ? "0 5%" : "0 10%"} m={"0 0 5%"}>
              <Text color={"#333333"} mb={"20px"} fontSize={convertFontSize(18, 24)} fontWeight={600}>
                {commission.title}
              </Text>
              <SimpleGrid columns={screen === "mobile" ? 2 : 4} gap={5}>
                {commission.contents.map((content, id) => {
                  return (
                    <Button 
                      key={id} 
                      background={type[index] === content.type ? "#333333" : "#ffffff"}
                      border={type[index] === content.type ? "1px solid #333333" : "1px solid #D9D9D9"}
                      color={type[index] === content.type ? "#ffffff" : "#333333"}
                      onClick={() => handleClick(index, content.type)}
                      fontSize={convertFontSize(12, 16)}
                    >
                      {content.title}
                    </Button>
                  )
                })}
              </SimpleGrid>
              {target && target === "Etc" && 
                <Stack w={"100%"} mt={"5%"}>
                  <Text color={"#333333"} fontSize={convertFontSize(16, 20)} display={"flex"} alignItems={"center"}>
                    직접 입력
                    <Circle />
                  </Text>
                  <Textarea 
                    h={"10vw"} 
                    border={"1px solid #D9D9D9"} 
                    resize={"none"} 
                    _focus={{ border: "1px solid #2EA090" }}
                    placeholder="원하시는 테스트를 작성해주세요." 
                    fontSize={convertFontSize(12, 16)}
                    color={"#333333"}
                    onChange={handleEtc}
                  />
                </Stack>
              }
            </Stack>
          )
        })}
        <Stack w={"100%"} p={screen === "mobile" ? "0 5%" : "0 10%"} m={"0 0 5%"}>
          <Text color={"#333333"} mb={"20px"} fontSize={convertFontSize(18, 24)} fontWeight={600}>
            {"03. 테스트 일정"}
          </Text>
          <Flex 
            w={"fit-content"} 
            h={"45px"} 
            border={"1px solid #333333"} 
            borderRadius={5}
            p={"10px 15px"} 
            justifyContent={"center"}
            alignItems={"center"}
            onClick={showCalendar} 
            position={"relative"}
          >
            <Text fontSize={convertFontSize(12, 16)} color={"#333333"}>
              {`${startDate && startDate !== "" ? startDate : "날짜 선택"}
               ~ 
              ${endDate && endDate !== "" ? endDate : "날짜 선택"}`}
            </Text>
            {calendar && (
              <StyledCalendar
                formatDay={(locale, date) => date.toLocaleString("en", { day: "numeric" })}
                value={dateRange as any}
                onChange={(value, event) => handleChangeCalendar(value, event)}
                prev2Label={null}
                next2Label={null}
                minDetail="year"
                maxDetail="month"
                selectRange
                minDate={new Date(Date.now() + 60*60*24*1000)}
                maxDate={new Date(Date.now() + 60*60*24*1000*366)}
                calendarType="gregory"
              />
            )}
          </Flex>
        </Stack>
        <Stack w={"100%"} p={screen === "mobile" ? "0 5%" : "0 10%"} m={"0 0 5%"}>
          <Flex w={"100%"} justifyContent={"space-between"} mb={"20px"}>
            <Stack w={"49%"}>
              <Text color={"#333333"} display={"flex"} alignItems={"center"}>이름<Circle /></Text>
              <Input 
                border={"1px solid #D9D9D9"} 
                p={screen === "mobile" ? "0 10px" : "0 16px"} 
                fontSize={convertFontSize(12, 16)} 
                color={"#333333"}
                placeholder="담당자명(회사명)을 입력해주세요."
                onChange={(e) => handleInfo(e, "name")}
              />
            </Stack>
            <Stack w={"49%"}>
              <Text color={"#333333"} display={"flex"} alignItems={"center"}>전화번호<Circle /></Text>
              <Input 
                border={"1px solid #D9D9D9"} 
                p={screen === "mobile" ? "0 10px" : "0 16px"} 
                fontSize={convertFontSize(12, 16)} 
                color={"#333333"}
                placeholder="전화번호를 입력해주세요."
                onChange={(e) => handleInfo(e, "phone")}
              />
            </Stack>
          </Flex>
          <Stack flex={1} mb={"5%"}>
            <Text color={"#333333"} display={"flex"} alignItems={"center"}>이메일<Circle /></Text>
            <Input 
              border={"1px solid #D9D9D9"} 
              p={screen === "mobile" ? "0 10px" : "0 16px"} 
              fontSize={convertFontSize(12, 16)} 
              color={"#333333"}
              placeholder="이메일을 입력해주세요."
              onChange={(e) => handleInfo(e, "email")}
            />
          </Stack>
          <Stack flex={1} mb={"20px"}>
            <Text color={"#333333"}>개인정보처리방침</Text>
            <Textarea 
              minH={"160px"} 
              border={"1px solid #D9D9D9"} 
              backgroundColor={"#F5F5F5"}
              p={"20px"}
              fontSize={convertFontSize(12, 14)}
              color={"#121212"} 
              resize={"none"} 
              readOnly 
              value={
                `개인정보 수집 동의 개인정보 수집 및 이용에 관한 안내개인정보의 제공을 거부하실 수 있으시나, 거부하실 경우 상담에 제한이 있습니다.\n\n`
                +`1. 개인 정보의 수집 • 이용 목적\n`
                +`• 본인확인, 문의사항 전달, 혜택 안내, 견적 상담\n`
                +`2. 수집하는 개인정보의 항목[필수]\n`
                +`• 기재하시는 이름 또는 회사명, 휴대전화 번호, 이메일 주소`
              } 
            />
          </Stack>
          <Flex justifyContent={"center"} alignItems={"center"} mb={"5%"} onClick={handleAgree} cursor={"pointer"}>
            <CheckButton ischeck={isAgree.toString()} />
            <Text color={"#818181"} fontSize={convertFontSize(12, 16)}>[필수] 상담을 위한 필수 개인정보 수집 및 활용에 동의합니다.</Text>
          </Flex>
          <Flex justifyContent={"center"}>
            <Button 
              w={screen === "mobile" ? "50vw" : "20vw"} 
              background={"#121212"} 
              color={"#ffffff"} 
              borderRadius={"30px"}
              onClick={handleSubmit}
            >
              보내기
            </Button>
          </Flex>
        </Stack>
      </Box>
    </Box>
  );
};

export default OutSourcing;